import React from 'react'
import { type LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import CertificateTypes from 'todistukset-common/src/vtj/CertificateTypes.enum'
import { ValidationError } from 'todistukset-common/src/vtj/form-validation.util'
import { FirstErrorImperativeHandle } from 'todistukset-ui/src/vtj/components/order-wizard/errors.util'
import StepRoutes from 'todistukset-ui/src/vtj/todistukset-step-routes.enum'
import OrderFlowName from 'todistukset-ui/src/vtj/OrderFlowName.enum'
import {
  AetSignerUiForm,
  AetOrdererUiForm,
  TodistusStoreForm,
  UaetUiForm,
} from 'todistukset-common/src/vtj/types/form-types.type'
import { TodistuksetUser } from 'todistukset-common/src/vtj/types/user'

export type ForwardRefWrappedComponent<RefType, PropsType> = ReturnType<
  typeof React.forwardRef<RefType, PropsType>
>

export type StepComponentProps = {
  titleId: string
  certificateType: CertificateTypes
  orderFlowName: OrderFlowName
}

export type StepComponent = ForwardRefWrappedComponent<
  FirstErrorImperativeHandle,
  StepComponentProps
>

export type OnClickParams = {
  onSuccess: () => void
}

type CertificateTypeParam = {
  certificateType: CertificateTypes
}

export enum StepButtons {
  NONE,
  NEXT,
  PREV_AND_NEXT,
  PREV_AND_ORDER,
  PREV_AND_SEND,
  PREV_AND_CONFIRM,
  PREV_AND_DECLINE,
  PREV_AND_CUSTOM_NEXT,
}

export type OnNextClick = (params: OnClickParams) => void

export type Step = {
  name: StepRoutes
  index: number
  component: StepComponent
  validations: {
    (
      params: CertificateTypeParam & {
        user: TodistuksetUser
        form:
          | TodistusStoreForm
          | AetOrdererUiForm
          | AetSignerUiForm
          | UaetUiForm
      }
    ): ValidationError[]
  }[]
  onPrevClick: (params: OnClickParams) => void
  useOnNextClick: () => OnNextClick | null
  buttons: StepButtons
  getPath: (lang: LanguageCode) => string
  isHidden?: boolean
  useCustomNextButton?: () => StepButtons
}
